import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import markdown from '@opsbase/react-markdown';
import useCss from '@opsbase/web-css';
import Vertical from '@opsbase/web-layout/Vertical';
import TextField from '@opsbase/web-textfield/TextField';
import Text from '@opsbase/web-ui/Text';
import React, { useState } from 'react';
import useTeamUpdate from "@opsbase/react-gql-hooks/team/useTeamUpdate";
import usePositionUpdate from "@opsbase/react-gql-hooks/position/usePositionUpdate";
const makeMyClasses = () => ({
    root: {
        backgroundColor: Palette.White.main,
    },
});
export default function AddTeamAndPosition(props) {
    const { team, position, setTeam, setPosition } = props;
    const updateTeam = useTeamUpdate();
    const updatePosition = usePositionUpdate();
    const [hasTeamChanged, setHasTeamChanged] = useState(false);
    const [hasPositionChanged, setHasPositionChanged] = useState(false);
    const myCss = useCss(makeMyClasses);
    return (React.createElement(Vertical, { gutter: true, paddingX: true },
        React.createElement(Text, { variant: 'h1' }, i18n.t('teams-and-roles')),
        React.createElement(Text, null, i18n.t('congrats-almost-done')),
        React.createElement(Text, null, markdown(i18n.t('teams-roles-line1'))),
        React.createElement(Text, null, i18n.t('teams-roles-which-team')),
        React.createElement(TextField, { autoFocus: true, placeholder: i18n.t('enter-name-of-new-team'), className: myCss.root, value: team ? team.title : '', onChange: value => {
                setTeam({ ...team, title: value });
                setHasTeamChanged(true);
            }, onBlur: async () => {
                if (hasTeamChanged) {
                    await updateTeam({
                        id: team.id,
                        patch: { title: team ? team.title : '' },
                    });
                }
            } }),
        React.createElement(Text, null, i18n.t('teams-roles-which-role')),
        React.createElement(TextField, { placeholder: i18n.t('enter-name-of-new-position'), className: myCss.root, value: position ? position.title : '', onChange: value => {
                setPosition({ ...position, title: value });
                setHasPositionChanged(true);
            }, onBlur: async () => {
                if (hasPositionChanged) {
                    await updatePosition({
                        id: position.id,
                        patch: {
                            title: position ? position.title : '',
                        },
                    });
                }
            } })));
}
